import { render } from "./FacebookIcon.vue?vue&type=template&id=04f7e984&bindings={}"
import script from "./FacebookIcon.vue?vue&type=script&lang=ts"
export * from "./FacebookIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script